<template>
  <div >
    <!-- 房管和主播查看名片 -->
    <div  class="roleDialog" @click.stop="" v-show="showCard" v-if="curUserInfo.userInfo" style="">
      <div style="
          width: 100%;
          height: 50%;
          box-sizing: border-box;
          padding: 7px;
          display: flex;
        ">
        <div @click="openDetails(curUserInfo.userInfo.uid)" style="
            cursor: pointer;
            margin-top: 10px;
            margin-left: 10px;
            width: 72px;
            height: 72px;
            overflow: hidden;
            border-radius: 50%;
            background: white;
          ">
          <img style="width: 100%; height: 100%; border-radius: 50%" :src="curUserInfo.userInfo.avatar" alt="" />
        </div>
        <div style="
            margin-left: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
          ">
          <div>
            <div style="display: flex; height: 30px; line-height: 30px">
              <div class="useall nickNames myfont">
                {{ curUserInfo.userInfo.nickname }}
              </div>
              &nbsp;
              <div style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                ">
                <img style="width: 36px; height: 16px" :src="
                    'https://oss.ansongqiubo.com//Image/grade/' +
                      curUserInfo.userInfo.level +
                      '.png'
                  " alt="" />
              </div>
              &nbsp;
              <div v-if="curUserInfo.userInfo.gender == 1" style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                ">
                <img style="width: 16px; height: 16px" src="https://oss.ansongqiubo.com//Image/mingpian/man.png"
                  alt="" />
              </div>
              <div v-if="curUserInfo.userInfo.gender == 2" style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                ">
                <img style="width: 16px; height: 16px"
                  src="https://oss.ansongqiubo.com//Image/mingpian/girl.png" alt="" />
              </div>
            </div>
            <div style="color: #666666; font-size: 14px">
              <span>龙珠号: </span><span class="useall">{{
                curUserInfo.userInfo.account
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="
          width: 92%;
          height: 1px;
          margin: 0 auto;
          background: #f2f2f2;
        "></div>
      <div style="width: 100%; height: calc(50% - 1px)">
        <div style="
            font-size: 14px;
            height: 33px;
            color: #333333;
            width: 92%;
            margin: 0 auto;
            box-sizing: border-box;
            padding-top: 7px;
          ">
          <span>{{ curUserInfo.userInfo.relation.follows }}关注 ·
            {{ curUserInfo.userInfo.relation.fans }}粉丝</span>
        </div>
        <div style="
            font-size: 12px;
            height: 33px;
            color: #666666;
            width: 92%;
            margin: 0 auto;
            box-sizing: border-box;
            margin-bottom: 3px;
          ">
          <div class="myfont2">简介: {{ curUserInfo.userInfo.desc?curUserInfo.userInfo.desc:'暂无简介'  }}</div>
        </div>
        <div style="
            cursor: pointer;
            color: #333333;
            font-size: 14px;
            height: 40px;
            background: #e4e4e4;
            width: 100%;
            display: flex;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 0 30px 0 30px;
          ">
          <div v-if="!isCare(curUserInfo.userInfo.uid)" @click="cardAttention(curUserInfo.userInfo.uid,true)"
            style="height: 40px; line-height: 40px">
            关注
          </div>
          <div v-else @click="cardAttention(curUserInfo.userInfo.uid,false)"
            style="height: 40px; line-height: 40px">
            已关注
          </div>
          <div @click="
              cardTA(
                curUserInfo.userInfo.nickname,
                curUserInfo.userInfo.uid
              )
            " style="height: 40px; line-height: 40px">
            @TA
          </div>
          <div @click="cardBanned(curUserInfo.userInfo.uid)" v-if="quanxian.mute == 1"
            style="height: 40px; line-height: 40px">
            禁言
          </div>
          <div @click="cardLoosenBanned(curUserInfo.userInfo.uid)" v-if="quanxian.mute == 2"
            style="height: 40px; line-height: 40px">
            解禁
          </div>
          <div @click="cardAdministrator(curUserInfo.userInfo.uid)" v-if="quanxian.manage == 1"
            style="height: 40px; line-height: 40px">
            设为管理员
          </div>
          <div @click="cardLoosenAdministrator(curUserInfo.userInfo.uid)" v-if="quanxian.manage == 2"
            style="height: 40px; line-height: 40px">
            解除管理员
          </div>
          <div @click="cardBan(curUserInfo.userInfo.uid)" v-if="quanxian.block == 1"
            style="height: 40px; line-height: 40px">
            封禁
          </div>
          <div @click="cardReport(curUserInfo.userInfo.uid)" style="height: 40px; line-height: 40px">
            举报
          </div>
        </div>
      </div>
      <img @click="showCard = false" class="tracqCss" style="position: absolute; top: 10px; right: 10px"
        src="https://oss.ansongqiubo.com//Image/priceImage/guanbi.png" alt="" />
    </div>
  </div>
</template>

<script>
  import {useroperation,profileuser,usermute} from '@/api/lz.js'
  import axios from 'axios'
  import qs from 'qs'
  export default {
    data() {
      return {
        curUserInfo:{},
        showCard:true,
        quanxian:{},
        tracqAttentionRelation:1,
        roomId:'',
        careList:[],
        nimparams:{}
      }
    },
    filters:{
      cardBrief(val){
        return val
      }
    },
    methods:{
      open(obj){
        console.log('打开状态',obj);
        this.Operation(obj);
      },
      close() {
        this.showCard = false
      },
      // 获取用户卡片可操作动作
      async Operation(obj) {
        // 获取用户信息
        let result = await profileuser({
          uid: obj.uid,
        })
        this.getcareList(1);
        if(result.data.code == 200){
          this.curUserInfo = result.data.data;
          this.showCard = true
        }
        useroperation({
          roomId:obj.roomId,
          uid: obj.uid,
        }).then((res) => {
            this.quanxian = res.data.data;
            console.log('当前用户权限',this.quanxian);
          });
      },
      // 打开个人中心
      openDetails(uid){

      },
      isCare(uid) {
        let arr = this.careList.filter((item) => item.uid == uid);
        if (arr && arr.length > 0) {
          return true;
        } else {
          return false;
        }
      },
      // 关注主播
      cardAttention(uid, state) {
       this.token = localStorage.getItem("token");
       if(!this.token){
         // this.$refs.navRef.Longin();
         console.log('跳转登录');
         return
       }
        if (state) {
          axios({
            headers: {
              device: "iOS",
              packageId: "1",
              version: "1.0.0",
              "authToken": this.token,
              "Content-Type": "application/x-www-form-urlencoded",
            },
            transformRequest: [
              function(data) {
                //在请求之前对data传参进行格式转换
                data = qs.stringify(data);
                console.log(data);
                return data;
              },
            ],
            url: this.api + "/v1/relation/follow",
            method: "post",
            data: {
              actionUid: uid,
            },
          }).then((res) => {
            this.$message({
              message: "关注成功",
              type: "success",
            });
            this.getcareList(2);
            console.log("关注主播", res);
          });
        } else {
          this.$confirm("取关该主播将无法及时收到消息, 是否取关?", "温馨提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              axios({
                headers: {
                  device: "iOS",
                  packageId: "1",
                  version: "1.0.0",
                  "authToken": this.token,
                  "Content-Type": "application/x-www-form-urlencoded",
                },
                transformRequest: [
                  function(data) {
                    //在请求之前对data传参进行格式转换
                    data = qs.stringify(data);
                    console.log(data);
                    return data;
                  },
                ],
                url: this.api + "/v1/relation/unfollow",
                method: "post",
                data: {
                  actionUid: uid,
                },
              }).then((res) => {
                console.log(res);
                this.$message({
                  message: "取关成功",
                  type: "success",
                });
                this.getcareList(2);
              });
            })
            .catch(() => {});
        }
      },
      // 获取关注列表
      async getcareList(type=1) {
       this.token = localStorage.getItem("token");
       if (this.token){
         let list = await this.$store.dispatch('getUserFollowData',type);
         console.log('我的关注列表·',list);
         this.careList = list;
       }
      },
      //  @TA
      cardTA(name,uid){
        this.$emit('sendMsg',{
          type:1,
          val: "@" + name + " "
        })
      },
      // 名片禁言
      cardBanned(uid){
          usermute({
            roomId: this.roomId,
            uid: e,
            nimFromAccid: this.nimparams.nimFromAccid,
            nimRoomId: this.nimparams.nimRoomId,
          }).then((res) => {
            if (res.data.message == "success") {
              this.Operation(e);
              this.$message({
                message: '禁言成功',
                type: 'success'
              })
            } else {
              this.$message({
                message: res.data.message,
                type: 'error'
              })
            }
          });
      },
      // 名片解禁
      cardLoosenBanned(uid){

      },
      // 名片设置管理员
      cardAdministrator(uid){

      },
      // 名片解开管理员
      cardLoosenAdministrator(uid){

      },
      // 封禁
      cardBan(uid){

      },
      // 打开举报
      cardReport(e){

      }
    }
  }
</script>

<style lang="scss" scoped>
  /*每个页面公共css */
  .myfont1 {
  	overflow: hidden; //隐藏文字
  	text-overflow: ellipsis; //显示 ...
  	white-space: nowrap; //不换
  }
  .myfont2 {
  	    word-break: break-all;
  	    text-overflow: ellipsis;
  	    display: -webkit-box;
  	    -webkit-box-orient: vertical;
  	    -webkit-line-clamp: 2; /* 这里是超出几行省略 */
  	    overflow: hidden;
  }
  .roleDialog{
    overflow: hidden;
    position: fixed;
    top: 46%;
    right: 9%;
    transform: translateX(50%);
    box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 1);
    z-index: 999;
    width: 280px;
    height: 214px;
    background: linear-gradient(180deg, #E5DCFF 0%, #F8F7FA 36%, #F7F8FA 100%);
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/lz_roledialog2.vue